import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import CapacidadFuncionalViewer from '../components/CapacidadFuncionalViewer';

export default function CapacidadFuncionalDetailPage() {
  const { idTipo, paciente } = useParams();

  return (
    <DashboardLayout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <CapacidadFuncionalViewer idTipo={idTipo} paciente={paciente} />
      </Container>
    </DashboardLayout>
  );
}
